import React from "react";
import i18n from "i18n";

import Step from "components/MainApp/atoms/Wizard/Step";
import SearchWithComponentsLocations from "components/MainApp/atoms/Filters/SearchWithComponentsLocations";
import ProductAddedListLocation from "components/MainApp/organisms/Orders/RequestOrders/ProductAddedListLocation";

import styles from "./PrepOrders.LoadPrepOrders.step2.module.scss";

export const RequestOrderStep2 = ({
  resultList,
  searchValue,
  handleChange,
  products,
  totalProducts,
  goBackFunc,
  handleSelectToAddProduct,
  handleChangedLocations,
  handleAdd,
  handleAddProduct,
  handleDeleteAddedProduct,
  selectedProducts,
  changePage,
  pagination,
  filter,
}) => {

  const filterProducts = (value) => {
    return filter(value);
  }
  
  const stepContent = (
    <div className={styles["request-order-step-two-content"]}>
      <div
        className={styles["request-order-step-two-field"]}
        data-automation-id="input-search"
      >
        <SearchWithComponentsLocations
          placeholder={i18n.t("search.by.name.or.code")}
          resultList={resultList}
          value={searchValue}
          handleChange={handleChange}
          handleSelectToAddProduct={handleSelectToAddProduct}
          handleChangedLocations={handleChangedLocations}
          handleAdd={handleAdd}
          selectedProducts={selectedProducts}
          onlyStockHidden={true}
          filterProducts={filterProducts}
        />

        {products.length > 0 && (
          <ProductAddedListLocation
            total={totalProducts}
            products={products}
            handleDelete={handleDeleteAddedProduct}
            changePage={changePage}
            pagination={pagination}
          ></ProductAddedListLocation>
        )}
      </div>
    </div>
  );
  return (
    <div className={styles["request-order-step-two-container"]}>
      <Step
        goBackFunc={goBackFunc}
        title={i18n.t("what.products.want.replenish")}
        content={stepContent}
      ></Step>
    </div>
  );
};

export default RequestOrderStep2;
